import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

// 🔄 Thunk to fetch scraped website data

export const getCompanyDetails = createAsyncThunk(
  "website/getCompanyDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiEndpoints.getOrganizationData,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);
export const getPeopleDetails = createAsyncThunk(
  "website/getPeopleDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiEndpoints.getPeopleData, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);



const websiteSlice = createSlice({
  name: "website",
  initialState: {
    websites: [],
    companyData: [],
    peopleData: [],
    promptCompanies: [],
    urlCompanies: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getCompanyDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.companyData = action.payload;
      })
      .addCase(getCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      

      .addCase(getPeopleDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPeopleDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.peopleData = action.payload;
      })
      .addCase(getPeopleDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default websiteSlice.reducer;
